import React from "react";
import { useLocation } from "react-router-dom";

import { useApiIdentities } from "api/services/useApiIdentities";
import { Modal } from "new-components/modals/Modal";

import { CreatedToken } from "./CreatedToken";
import { CreateForm } from "./CreateForm";

interface CreateApiTokenDialogProps {
  isDialogOpen: boolean;
  onCloseDialog: () => void;
}

export function CreateApiTokenDialog(props: CreateApiTokenDialogProps) {
  const { isDialogOpen, onCloseDialog } = props;

  const seachParams = new URLSearchParams(useLocation().search);
  const origin = seachParams.get("origin");

  const { createApiIdentityAsync, createdApiIdentity, isCreatingApiIdentity } = useApiIdentities();

  const handleCloseDialog = () => {
    onCloseDialog();
  };

  return (
    <Modal
      title={createdApiIdentity ? undefined : "Create API token"}
      size={createdApiIdentity ? "medium" : "small"}
      maxWidth={createdApiIdentity ? undefined : "720px"}
      // Tall enough for Expiration + Automatic rotation helpers and the create button.
      maxHeight={createdApiIdentity ? undefined : "680px"}
      open={isDialogOpen}
      onClose={handleCloseDialog}
      // Fixed size for the create form so toggles do not resize the dialog.
      isFluid={!!createdApiIdentity}
      body={
        !createdApiIdentity ? (
          <CreateForm
            isLoading={isCreatingApiIdentity}
            createApiIdentity={createApiIdentityAsync}
            onClose={handleCloseDialog}
          />
        ) : (
          <CreatedToken
            apiToken={{
              name: createdApiIdentity.name,
              raw_key: createdApiIdentity.raw_key,
              expires_at: createdApiIdentity.token_expires_at,
            }}
            defautlShowQR={!!origin}
            onClose={handleCloseDialog}
          />
        )
      }
    />
  );
}
